import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageComponent from "../Layouts/ImageComponent";
import _ from "lodash";
import { useState } from "react";
import CartPopUpComponent from "../NewDesign/DetailPage/CartPopUp/CartPopUpComponent";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import useLogin from "../../custom-hooks/useLogin";
import { getFileTypeName } from "../../utils/AppUtils";
import { useTranslation } from "react-i18next";
import "./ModuleSingleCardComponent.scss";
const ModuleSingleCardComponent = (props) => {

    const {
        index, item, navigateToDetails, productData, hasTeaser,
        setIsLoading
    } = props
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false)
    const { isLoggedIn } = useLogin()

    return (
        <>

        <div class="card">
		<h3 class="credit" aria-label={item.title}><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.9728 16.6427C22.0461 16.9801 21.9948 17.2954 21.8188 17.5887C21.6428 17.8821 21.3935 18.0801 21.0708 18.1827L12.4468 21.1087L9.30081 21.1747L6.68281 21.1967C6.41881 21.1967 6.23548 21.1894 6.13281 21.1747C5.97148 21.1601 5.84681 21.1161 5.75881 21.0427C5.15748 20.8374 3.41948 20.3021 0.544812 19.4367L-0.00518799 19.2827V10.8127L6.79281 12.6387L7.73881 13.3867L13.9648 14.1127C14.2875 14.1421 14.5515 14.2741 14.7568 14.5087C14.9768 14.7287 15.0941 15.0001 15.1088 15.3227L18.6288 14.9707C19.4795 14.8827 20.0881 14.8314 20.4548 14.8167C20.8215 14.8021 21.0781 14.8021 21.2248 14.8167C21.3128 14.8461 21.4008 14.8974 21.4888 14.9707L21.5328 15.0147L21.5768 15.0807C21.7821 15.7407 21.9141 16.2614 21.9728 16.6427ZM1.51281 12.8147L1.53481 18.1387C4.29215 18.9601 5.92015 19.4734 6.41881 19.6787C6.82948 19.6787 8.75815 19.6421 12.2048 19.5687L20.4548 16.7967L20.3668 16.3567C19.8095 16.4007 18.5555 16.5181 16.6048 16.7087L15.0868 16.8627C15.0135 17.2294 14.8448 17.5301 14.5808 17.7647C14.3168 17.9994 14.0015 18.1167 13.6348 18.1167H6.72681V16.5987H13.5908V15.6087L7.14481 14.8607L6.11081 14.0247L1.51281 12.8147ZM10.9948 8.37074C10.4961 8.37074 10.0341 8.24607 9.60881 7.99674C9.19814 7.7474 8.86815 7.4174 8.61881 7.00674C8.36948 6.5814 8.24481 6.1194 8.24481 5.62074C8.24481 5.12207 8.36948 4.6674 8.61881 4.25673C8.86815 3.8314 9.19814 3.49407 9.60881 3.24474C10.0341 2.9954 10.4888 2.87074 10.9728 2.87074C11.4715 2.87074 11.9335 2.9954 12.3588 3.24474C12.7841 3.4794 13.1215 3.8094 13.3708 4.23473C13.6201 4.6454 13.7448 5.10007 13.7448 5.59874C13.7448 5.9654 13.6715 6.3174 13.5248 6.65474C13.3928 6.99207 13.2021 7.29274 12.9528 7.55674C12.7035 7.80607 12.4101 8.00407 12.0728 8.15074C11.7355 8.2974 11.3835 8.37074 11.0168 8.37074H10.9948ZM10.9948 4.27874C10.6135 4.27874 10.2908 4.41074 10.0268 4.67474C9.77748 4.93874 9.65281 5.25407 9.65281 5.62074C9.65281 5.9874 9.78481 6.30273 10.0488 6.56674C10.1661 6.68407 10.3055 6.7794 10.4668 6.85274C10.6428 6.92607 10.8188 6.96274 10.9948 6.96274C11.3761 6.94807 11.6915 6.80874 11.9408 6.54474C12.2048 6.28074 12.3295 5.9654 12.3148 5.59874C12.3148 5.23207 12.1828 4.92407 11.9188 4.67474C11.6695 4.41074 11.3541 4.27874 10.9728 4.27874H10.9948ZM2.74481 10.4387V0.802734H19.9268V10.4387H2.74481ZM4.13081 2.18873V9.05274H18.5628V2.18873H4.13081Z" fill="#252525"/>
</svg> {item.title}</h3>
		<p>Take a quick, guided check-in to help you understand where you are financially and how to move forward.</p>
		<p class="small">Takes just 5 minutes. Quick and easy, no prep needed.</p>
		<a  class="button" tabIndex={0} onClick={()=>{navigateToDetails(item.title,item.progress,item);}}>Start <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.08 7.50374L8.576 1.98374C8.48 1.88774 8.432 1.77041 8.432 1.63174C8.432 1.49308 8.48 1.37574 8.576 1.27974C8.672 1.18374 8.78933 1.13574 8.928 1.13574C9.06667 1.13574 9.184 1.18374 9.28 1.27974L16 7.99974L9.28 14.7197C9.184 14.8157 9.06667 14.8637 8.928 14.8637C8.78933 14.8637 8.672 14.8157 8.576 14.7197C8.48 14.6237 8.432 14.5064 8.432 14.3677C8.432 14.2291 8.48 14.1117 8.576 14.0157L14.08 8.49574H0.496C0.357333 8.49574 0.24 8.44774 0.144 8.35174C0.048 8.25574 0 8.13841 0 7.99974C0 7.86108 0.048 7.74374 0.144 7.64774C0.24 7.55174 0.357333 7.50374 0.496 7.50374H14.08Z" fill="#415385"/>
</svg>
</a>
	  </div>

            {false && <div className="modulesection" id={`module-crs-${item.module_id}`}>
                <span className="module-title">
                    {"Module " + (index + 1)}
                </span>

                <h3 style={{ color: "black" }}>{item.title}</h3>
                <ul className="moduleinner-list">
                    <li>
                        {
                            // !_.isEmpty(item.rsp_toolkit) &&
                            // _.isArray(item.rsp_toolkit)
                            // ? item.rsp_toolkit[0].title
                            // : 
                            getFileTypeName(item.file_type)}
                    </li>
                    <li>{item.durationTime}</li>
                </ul>
                <div className="image-blocklp">
                <ImageComponent
                    thumbnail={
                        item.thumbnail ? item.thumbnail : ""
                    }
                    name={item.title}
                    cssClass={`img-fluid galleryImg ${item.isLock ? "grayscale" : ""
                        }`}
                    errorClass={`img-fluid grayscale d-flex justify-content-center align-items-center bk-grey ${item.isLock ? "grayscale" : ""
                        }`}
                />
                </div>

                <OverlayTrigger
                    key="bottom"
                    placement="top-start"
                    overlay={
                        <Tooltip id={`tooltip-bottom`}>
                            <div
                                style={{
                                    color: "white",
                                    backgroundColor: "transparent",
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: item?.desc,
                                }}
                            ></div>
                        </Tooltip>
                    }
                >
                    <div className="discription-detail"
                        dangerouslySetInnerHTML={{
                            __html:item.desc,
                        }}
                    ></div>
                </OverlayTrigger>

                <div className="progress-rowsec">
                    <div className="d-flex gap-3 progress-content position-relative">
                        <div className="progress-rowbar">
                            <div
                                className="progress"
                                role="progressbar"
                                aria-label="Basic example"
                                aria-valuenow={item.progress}
                                aria-valuemin="0"
                                aria-valuemax="100"
                            >
                                <div
                                    className="progress-bar"
                                    style={{ width: item.progress + "%" }}
                                ></div>
                            </div>
                        </div>
                        <span className="progress-text">
                            {_.isNumber(item?.progress) ? item?.progress : item?.progress?.split(".")[0]}%
                        </span>
                    </div>
                    {
                        productData.isLoadingPriceInfo ?
                            <ShimmerScreen
                                width="8rem"
                                height="2rem"
                                case="rect"
                            />
                            :
                            <>
                                {
                                productData.isPaid ?
                                    hasTeaser
                                        ?
                                        <button
                                            type="button"
                                            className={`${item.isLock
                                                ? "startcourse-btn cursor-not-allowed"
                                                : "startcourse-btn cursor-pointer"
                                                }`}
                                            onClick={() => {
                                                navigateToDetails(
                                                    item.title,
                                                    item.progress,
                                                    item
                                                );
                                            }}
                                        >
                                            {item.progress > 0
                                                ? t("Restart module")
                                                : t("Free trail Access")}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#415385" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </button>
                                        :
                                        <button
                                            type="button"
                                            className="startcourse-btn cursor-pointer"
                                            onClick={() => {
                                                setIsOpen(true)
                                            }}
                                        >
                                            {t("Purchase to unlock")}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#415385" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </button>
                                    :
                                    <button
                                        type="button"
                                        className={`${item.isLock
                                            ? "startcourse-btn cursor-not-allowed"
                                            : "startcourse-btn cursor-pointer"
                                            }`}
                                        onClick={() => {
                                            navigateToDetails(
                                                item.title,
                                                item.progress,
                                                item
                                            );
                                        }}
                                    >
                                        {item.progress > 0
                                            ? item.progress < 100 ? t("Resume module") : t("Restart module")
                                            : t("Start module")}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331" stroke="#415385" strokeWidth="1.66667" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </button>
                                }
                            </>
                    }
                </div>
            </div>}
            <CartPopUpComponent
                isOpen={isOpen}
                productData={productData}
                closeAction={() => setIsOpen(false)}
                isSubscription={false}
                setMainPageLoading={setIsLoading}
            />
        </>
    )
}

export default ModuleSingleCardComponent